// Следим за добавлением элементов с помощью MutationObserver
export class ScrollbarObserver {
  constructor() {
    this.observer = new MutationObserver((mutationsList) => {
      mutationsList.forEach((mutation) => {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach((node) => {
            // Проверяем, является ли добавленный узел контейнером скролла
            if (node.nodeType === 1 && node.matches('.scroll-container')) {
              new CustomScrollbar(node); // Инициализируем кастомный скроллбар для нового элемента
            }

            // Проверяем вложенные узлы на наличие контейнеров скролла
            if (typeof node.querySelectorAll !== 'undefined') {
              const scrollContainers = node.querySelectorAll('.scroll-container');
              scrollContainers.forEach((scrollContainer) => {
                new CustomScrollbar(scrollContainer); // Инициализируем кастомный скроллбар для вложенных элементов
              });
            }
          });
        }
      });
    });

    // Наблюдаем за изменениями в DOM
    this.observeDocument();
  }

  observeDocument() {
    this.observer.observe(document.body, {
      childList: true,
      attributes: true,
      subtree: true // Включаем наблюдение за вложенными узлами
    });

    // Инициализируем кастомные скроллбары для существующих элементов
    document.querySelectorAll('.scroll-container').forEach((scrollContainer) => {
      new CustomScrollbar(scrollContainer);
    });
  }
}
